import { compose, withProps } from "recompose";
import { graphql } from "react-apollo";
import branchServerClient from "web/core/branchServerClient";
import withGenderFilter from "theme/components/helpers/withGenderFilter";

const withGalleryImages = (ProductGalleryQuery) =>
  compose(
    graphql(ProductGalleryQuery, {
      options: ({ sku }) => ({
        variables: {
          sku: sku,
        },
      }),
      props: ({ data, ownProps }) => ({
        images: typeof data.product !== "undefined" ? data.product.images : [],
      }),
    }),
    withGenderFilter(),
    withProps((props) => {
      if (!props.src) {
        return {};
      }
      let mainImage = {
        file: props.src,
        alt: props.name,
        id: props.sku,
      };
      let filteredImages = props.images.filter(
        (image) => image.file !== mainImage.file
      );
      if (props.currentGender && [300, 299].includes(props.currentGender)) {
        filteredImages = filteredImages.filter((image) => {
          if (props.currentGender === 300) {
            return image.disabled_women === true ? false : true;
          } else if (props.currentGender === 299) {
            return image.disabled_men === true ? false : true;
          }
          return true;
        });
      }
      if (
        props.isAdultGender &&
        props.adult_image &&
        props.adult_image !== "no_selection"
      ) {
        if (mainImage.file.indexOf(props.adult_image) === -1) {
          filteredImages.forEach((item, index) => {
            if (item.file.indexOf(props.adult_image) !== -1) {
              filteredImages.push(mainImage);
              filteredImages = filteredImages.filter(
                (elem) => elem.file !== item.file
              );
              mainImage = item;
            }
          });
        }
      }
      return {
        mainImage,
        images: [mainImage, ...filteredImages],
      };
    })
  );

const EnhanceProductGallery = ({ ProductGalleryQuery }) =>
  compose(
    branchServerClient(
      (BaseComponent) => BaseComponent,
      withGalleryImages(ProductGalleryQuery)
    )
  );

export default EnhanceProductGallery;
